import { Result } from 'core/infrastructure';

export default function addPrecondition<T extends (...args: any[]) => Promise<Result<any>>>(precondition: () => boolean, func: T) {
	return (...args: Parameters<T>): ReturnType<T> => precondition() ? func(...args) as any : Promise.resolve(Result.error());
}
